
import SunFog from "../../../assets/outline/SunFog.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SunFogIcon({ className, dataTestid = "SunFogIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SunFog data-testid={dataTestid} className={classes} {...rest} />
  );
}
